import cls from '@utils/css-select';
import React from 'react';
import styles from './styles.scss';

const cx = cls(styles)

type pageContainer = {
	className?: string;
	style?: React.CSSProperties;
	children: React.ReactNode;
	footerVision?: boolean;
}

function PageContainer(props: pageContainer) {

	const { style, className, children, footerVision = true } = props

	return (
		<div className={cx('page-container', className)} style={style}>
			{/* <Header style={{ 'background': '#fff' }} /> */}
			<main>
				<div className={cx('center')}>
					{children}
				</div>
			</main>
			{/* {footerVision && <Footer />} */}
		</div>
	)
}

export default PageContainer
